import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Form from 'antd/lib/form';
import Button from 'antd/lib/button';
import { Link } from 'react-router';
import { paymentStatus, paymentStatusT } from '../../../common/enums';
import { formatDateTime, currencyFormatter } from '../../../common/utils/helpers';
import { CreditorPaymentModal, DebtorPaymentModal, PaymentDivisionModal, RefundationModal } from './';

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};

const tailFormItemLayout = {
  wrapperCol: {
    span: 14,
    offset: 6,
  },
};

@translate()
export default class PaymentDetail extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    payment: PropTypes.object,
    onAssignToCreditor: PropTypes.func.isRequired,
    onAssignToLoan: PropTypes.func.isRequired,
    onRefundPayment: PropTypes.func.isRequired,
  };

  state = {
    show: false,
    showRefund: false,
    visible: false,
  }

  showModal = e => {
    this.setState({
      show: !this.state.show
    });
  };

  showRefundModal = e => {
    this.setState({
      showRefund: !this.state.showRefund
    });
  };

  render() {
    const { payment, onAssignToCreditor, onAssignToLoan, onRefundPayment, onShiftPayment, t, account, fullAccountName } = this.props;

    return (
      <div>
        <h1>{t('Detail platby')}</h1>
        <Form>
          <Form.Item {...formItemLayout} label={t('ID')}>
            <span>{payment.id}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Celková suma')}>
            <span>{currencyFormatter(payment.amount)}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Použitá suma')}>
            <span>{currencyFormatter(payment.amountUsed)}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Variabilný symbol')}>
            <span>{payment.variableSymbol}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('IBAN odosielateľa')}>
            <span>{payment.ibanFrom}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('IBAN prijímateľa')}>
            <span>{payment.ibanTo}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Meno majiteľa účtu')}>
            <span>{payment.accountName}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Správa')}>
            <span>{payment.message}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Stav')}>
            <span>{paymentStatusT[payment.status]}</span>
          </Form.Item>

          {payment.account && (
            <Form.Item {...formItemLayout} label={t('Investor')}>
              <Link to={`/admin/accounts/${payment.account.id}/profile`}>
                {payment.account.nameFirst} {payment.account.nameLast}
              </Link>
            </Form.Item>
          )}

          {payment.loan && (
            <Form.Item {...formItemLayout} label={t('Pôžička')}>
              <Link to={`/admin/loans/${payment.loan.id}`}>{payment.loan.id}</Link>
            </Form.Item>
          )}

          {payment.transferredAt && (
            <Form.Item {...formItemLayout} label={t('Dátum transakcie')}>
              <span>{formatDateTime(payment.transferredAt)}</span>
            </Form.Item>
          )}

          <Form.Item {...formItemLayout} label={t('Vytvorené')}>
            <span>{formatDateTime(payment.createdAt)}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Upravené')}>
            <span>{formatDateTime(payment.updatedAt)}</span>
          </Form.Item>

          {payment.status === paymentStatus.RECEIVED && (
            <Form.Item {...tailFormItemLayout}>
              <CreditorPaymentModal onSubmit={onAssignToCreditor}>
                <Button size="default" className="btn-inline">
                  {t('Priradiť k investorovi')}
                </Button>
              </CreditorPaymentModal>
              <DebtorPaymentModal onSubmit={onAssignToLoan}>
                <Button size="default" className="btn-inline">
                  {t('Priradiť k splátke')}
                </Button>
              </DebtorPaymentModal>
            </Form.Item>
          )}

          {payment.status === paymentStatus.RECEIVED && (
            <Form.Item {...tailFormItemLayout}>
              <Button size="default" className="btn-inline" onClick={e => {this.showRefundModal();}}>
                {t('Refundovať')}
              </Button>

              <Button size="default" className="btn-inline" onClick={e => {this.showModal();}}>
                {t('Rozdelenie platby')}
              </Button>
            </Form.Item>
          )}

        </Form>
        <RefundationModal payment={payment} onClose={this.showRefundModal} show={this.state.showRefund}></RefundationModal>
        <PaymentDivisionModal payment={payment} onClose={this.showModal} show={this.state.show}></PaymentDivisionModal>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/payment-management/components/PaymentDetail.js